import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export default function ClinicHeaderUser() {
  const { clinicUser, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/clinic-login", { replace: true });
  };

  if (!isAuthenticated || !clinicUser) {
    return (
      <span className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-100 text-[10px] font-semibold text-foreground-700">
        <span className="w-3 h-3 flex items-center justify-center">
          <i className="ri-lock-line text-[9px]"></i>
        </span>
        Secure Clinical Backend
      </span>
    );
  }

  return (
    <>
      <span className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-green-100 text-[10px] font-semibold text-green-700">
        <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
        <span className="max-w-[140px] truncate">{clinicUser.clinicName}</span>
      </span>
      <button
        type="button"
        onClick={handleLogout}
        className="flex items-center gap-1.5 text-[11px] md:text-xs font-semibold text-foreground-500 hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-logout-box-r-line text-xs"></i>
        </span>
        <span className="hidden sm:inline">Sign Out</span>
      </button>
    </>
  );
}
